import React, { FC, useCallback, useState } from 'react';
import { Grid, IconButton } from '@material-ui/core';
// import SVGExternalLink from '@assets/SVGExternalLink';
// import { isMobile } from '@utils';
import SVGBackArrow2 from '@assets/SVGBackArrow2';
import SVGFile from '@assets/SVGFile';
import SVGEmail from '@assets/SVGEmail';
import useStyles from './styles';
import Option from './Option';
import EmailPanel from './Panels/Email';
import ScriptPanel from './Panels/Script';
import { SCRIPT_GENERATOR_TABS } from '@constants/constants';
// import SVGExternalLink from '@assets/SVGExternalLink';
// import RenderIf from '@components/RenderIf';

interface ILeftSideProps {
  scriptResult: {
    videoScript?: string;
    contentScript?: string;
    subjectScript?: string;
  };
  onBack: () => void;
  generateEmailScript: () => void;
  handleScriptContentOpener?: (text: string, section: string) => void;
  loading?: boolean;
}

const LeftSide: FC<ILeftSideProps> = ({
  scriptResult,
  onBack,
  generateEmailScript,
  // handleScriptContentOpener,
  loading = false,
}) => {
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState(SCRIPT_GENERATOR_TABS.SCRIPT);
  // const isMobileDevice: boolean = !!isMobile()

  const getOptionColor = useCallback((tab: string) => {
    if (currentTab === tab) {
      return '#7747D8'
    }

    if (loading) {
      return "#00000042"
    }

    return '#000'
  },[currentTab, loading])

  return (
    <>
      <div className={classes.leftHeader}>
        <IconButton className={classes.leftHeaderButton} onClick={onBack} disabled={loading}>
          <SVGBackArrow2 />
        </IconButton>
        <Grid
          container
          direction="row"
          alignItems="center"
          justify="center"
          item
          xs={12}
        >
          <Option
            id={SCRIPT_GENERATOR_TABS.SCRIPT}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
            icon={<SVGFile color={getOptionColor(SCRIPT_GENERATOR_TABS.SCRIPT)} />
            }
            label="Script"
            disabled={loading}
          />
          <Option
            id={SCRIPT_GENERATOR_TABS.EMAIL}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
            icon={<SVGEmail color={getOptionColor(SCRIPT_GENERATOR_TABS.EMAIL)}/>}
            onOptionClick={generateEmailScript}
            label="Email"
            disabled={loading}
          />
        </Grid>
        {/* Hide until we apply a better approach */}
        {/* <RenderIf condition={!isMobileDevice}>
          <IconButton className={classes.leftHeaderButton} onClick={() => {
            handleScriptContentOpener(
              currentTab === SCRIPT_GENERATOR_TABS.SCRIPT ?
                scriptResult?.videoScript || '' :
                `${scriptResult?.subjectScript}: ${scriptResult?.contentScript}`,
              currentTab
            )
          }} disabled={currentTab === SCRIPT_GENERATOR_TABS.SCRIPT ? !scriptResult?.videoScript : !scriptResult.subjectScript}>
            <SVGExternalLink />
          </IconButton>
        </RenderIf> */}
      </div>
      <div className={classes.leftContent}>
        <ScriptPanel
          id={SCRIPT_GENERATOR_TABS.SCRIPT}
          currentTab={currentTab}
          content={scriptResult?.videoScript}
        />
        <EmailPanel
          id={SCRIPT_GENERATOR_TABS.EMAIL}
          currentTab={currentTab}
          content={{
            contentScript: scriptResult.contentScript,
            subjectScript: scriptResult.subjectScript,
          }}
        />
      </div>
    </>
  );
};

export default LeftSide;
